function getValidLocale(code) {
    const validLocale = Intl.DateTimeFormat.supportedLocalesOf([code]);
    // Chrome 88 on Android appears to have a bug where
    // `Intl.DateTimeFormat.supportedLocalesOf` returns an empty array even for
    // well-known locale codes. We need to ensure a valid string return value OR
    // undefined; functions like Date#toLocaleDateString throw if passed `null`
    // but not undefined.
    return validLocale && validLocale.length === 1 ? validLocale[0] : undefined; // eslint-disable-line no-undefined
}

function getCode(tag) {
    return tag.language && tag.region
        ? `${tag.language}-${tag.region}`
        : tag.language;
}

/**
 * Constructs a localization data object by parsing either a moniker or BCP-47
 * language tag. The constructed object will be composed of the following
 * properties:
 *      data: Original passed in value.
 *      brand: Brand variant (eg. HA, VRBO).
 *      code: BCP-47 style language tag (ie. no brand variant).
 *      language: The language of the locale (ie. en). ISO 639.
 *      region: The country code (ie. US). ISO 3166-1.
 * @param {string} locale - A moniker or BCP-47 language code.
 */
// eslint-disable-next-line complexity
function LanguageTag(locale) {
    locale = locale ? locale.trim() : '';
    const tags = locale.split(/_|-/);

    this.data = locale;
    this.language = tags[0] && tags[0].length === 2 ? tags[0] : undefined; // eslint-disable-line
    this.region =
        tags.length > 1 && tags[1] && tags[1].length === 2 ? tags[1] : null;
    this.brand = tags.length > 2 && tags[2] ? tags[2] : null;

    // Validate a BCP-47 style language tag based on the language and region.
    try {
        let code = getCode(this);

        // no-NO is not supported on most browsers, fallback to nb-NO if it's not supported
        if (!getValidLocale(code) && this.language === 'no') {
            this.language = 'nb';
            code = getCode(this);
        }

        this.code = getValidLocale(code);
    } catch (e) {
        // Ignore error, code will be undefined.
    }
}

module.exports = LanguageTag;
